import {Button, useToggle, ButtonsList, debounce, Attention} from '@vidazoo/ui-kit';
import HistoryReportsButton from '../historyReportsButton/HistoryReportsButton';
import theme from './theme.module.scss';
import useUserManager from '../../../../common/hooks/useUserManager';
import React, {useCallback, useEffect, useState} from 'react';
import NameFieldModal from '../nameFieldModal/NameFieldModal';
import useReportingParamsManager from '../../common/hooks/useReportingParamsManager';
import useReportingPresetReportsManager from '../../common/hooks/useReportingPresetReportsManager';
import {observer} from 'mobx-react';
import useReportingModel from '../../common/hooks/useReportingModel';
import PresetsSelect from "../presetsSelect/PresetsSelect";
import CreatePresetModel from "../createPresetModel/CreatePresetModel";

const minWindowWidthToGroupActions = 1400;

function ReportingActions({onFullScreen}: {onFullScreen?: () => void}) {
    const {resetParams} = useReportingParamsManager();
    const model = useReportingModel();
    const {executionTime, generateReportLink, downloadCSV} = model;
    const reportActionsDisabled = model.isLoading || model.reportIsEmpty || !model.results?.result?.length;

    const [echoButtons, setEchoButtons] = useState(shouldEchoButtons(window.innerWidth));

    function shouldEchoButtons(windowWidth: number): boolean {
        return minWindowWidthToGroupActions > 0
            ? windowWidth > minWindowWidthToGroupActions
            : true;
    }

    const debouncedOnWindowResize = useCallback(debounce(() => {
        requestAnimationFrame(() => {
            const ww = window.innerWidth;
            setEchoButtons(shouldEchoButtons(ww));
        });
    }, 100), [minWindowWidthToGroupActions]);

    useEffect(() => {
        if (minWindowWidthToGroupActions) {
            window.addEventListener("resize", debouncedOnWindowResize, false);
        }

        return () => {
            if (minWindowWidthToGroupActions) {
                window.removeEventListener("resize", debouncedOnWindowResize, false);
            }
        };
    }, [debouncedOnWindowResize]);

    return (
        <div>
            <div className={theme.actions}>
                <div>
                    <ButtonsList label="Reporting Actions" echo={echoButtons}>
                        <div className={theme.buttons}>
                            <Button iconName="icon-download" medium flat disabled={reportActionsDisabled}
                                    onClick={downloadCSV}>
                                Download CSV
                            </Button>
                            <Button iconName="icon-link" medium flat type="button"
                                    onClick={generateReportLink}>Copy Link</Button>
                        </div>
                    </ButtonsList>
                </div>
                <PresetsSelect/>
                <div>
                    {executionTime ? (
                        <Attention className={theme.executionTime} label={`Last execution time: ${Math.ceil(executionTime / 1000)}s`}/>
                    ) : null}
                </div>
                <div className={theme.primaryActions}>
                    {onFullScreen && <Button type="button" iconName="icon-expand-small" uppercase gray medium onClick={onFullScreen}>Full screen</Button>}
                    <Button type="button" uppercase gray medium onClick={resetParams}>Clear All</Button>
                    <HistoryReportsButton/>
                    <Button type="submit" uppercase blue medium>
                        Generate Report
                    </Button>
                </div>
            </div>
            <CreatePresetModel/>
        </div>
    )
}

export default observer(ReportingActions);
